import { render, staticRenderFns } from "./goods_type.vue?vue&type=template&id=9ea9e262&"
import script from "./goods_type.vue?vue&type=script&lang=js&"
export * from "./goods_type.vue?vue&type=script&lang=js&"
import style0 from "./goods_type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports